<div class="container-fluid mb-5 px-3">
    <div class="row mt-3 d-flex justify-content-between">
        <mat-card-title class="font-weight-bold">
            <h1>Import Reservation Data</h1>
        </mat-card-title>
        <div class="row">
            <mat-card class="mt-3 pb-5">
                <div class="row justify-content-center">
                    <div class="col-12">
                        <div class="mt-5 px-3">
                            <div class="row justify-content-center" [formGroup]="reservationDataForm">
                                <div class="col d-flex flex-column">
                                    <mat-form-field appearance="outline" hideRequiredMarker>
                                        <mat-label>Organization ID <span class="required-input">*</span></mat-label>
                                        <input type="number" matInput formControlName="organizationId" min="0" step="1" oninput="this.value = this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                        <mat-error *ngIf="!reservationDataForm.get('organizationId')?.value">Required</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex flex-column px-3">
                                    <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload accept=".xlsx">
                                    <div class="file-upload">
                                        {{ fileName || "Select File" }}
                                        <button mat-mini-fab class="upload-btn" (click)="fileUpload.click()">
                                            <mat-icon>attach_file</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <div class="col d-flex flex-column">
                                    <mat-form-field appearance="outline" hideRequiredMarker>
                                        <mat-label>Created Date <span class="required-input">*</span></mat-label>
                                        <input matInput [matDatepicker]="picker" formControlName="createdDate">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-error *ngIf="!reservationDataForm.get('created_date')?.value">Required</mat-error>
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex flex-column">
                                    <button class="action-button review-btn" mat-raised-button (click)="onReviewReservationDataClick()" [disabled]="!reservationDataForm.valid || !this.fileName">
                                        <mat-icon>search</mat-icon>
                                        Review
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</div>